import { useDispatch, useSelector } from 'react-redux';
import { SectionHeader } from '../Header/SectionHeader';
import InputField from '../input/inputField';
import {
  setFatherInfo,
  setMotherInfo,
  SelectedParents as SelectedParentsModal,
} from '../../Redux/Slices/studentAdmission.slice';
import { RootState } from '../../Redux/store';
import { useEffect } from 'react';
import { ParentalRelationship } from '../../Constants/Enums/parents.enum';

export const StudentAdmissionFormStepThree = () => {
  const {
    fatherInfo,
    motherInfo,
    selectedParents = {} as SelectedParentsModal,
  } = useSelector((state: RootState) => ({
    motherInfo: state.studentAdmission.motherInfo,
    fatherInfo: state.studentAdmission.fatherInfo,
    selectedParents: state.studentAdmission.selectedParents,
  }));

  const dispatch = useDispatch();
  const setUpdatedFatherInfo = (value: any) => {
    dispatch(setFatherInfo({ ...fatherInfo, ...value }));
  };
  const setUpdatedMotherInfo = (value: any) => {
    dispatch(setMotherInfo({ ...motherInfo, ...value }));
  };

  useEffect(() => {
    switch (selectedParents?.parentalRelationship) {
      case ParentalRelationship.FATHER:
        dispatch(
          setFatherInfo({
            name: selectedParents.name,
            mobile: selectedParents.mobile,
          })
        );
        break;
      case ParentalRelationship.MOTHER:
        dispatch(
          setMotherInfo({
            name: selectedParents.name,
            mobile: selectedParents.mobile,
          })
        );
        break;
      default:
        return;
    }
  }, [selectedParents, dispatch]);
  return (
    <div className="flex flex-row gap-x-32">
      <div className="flex-1">
        <SectionHeader
          headerText="Father info"
          subText="Please provide essential details about the student's father for admission purposes."
        />
        <InputField
          value={fatherInfo?.name || ''}
          setValue={(value) => {
            setUpdatedFatherInfo({
              name: value,
            });
          }}
          label="Name*"
          name="new-student-father-name"
          isRequiredFocusonValidation
        />
        <InputField
          value={fatherInfo?.mobile || ''}
          setValue={(value) => {
            setUpdatedFatherInfo({
              mobile: value,
            });
          }}
          label="Mobile*"
          name="new-student-father-mobile"
          isRequiredFocusonValidation
        />
        <InputField
          value={fatherInfo?.telno || ''}
          setValue={(value) => {
            setUpdatedFatherInfo({
              telno: value,
            });
          }}
          label="Tel no"
          name="new-student-father-telno"
          isRequiredFocusonValidation
        />
        <InputField
          value={fatherInfo?.occupation || ''}
          setValue={(value) => {
            setUpdatedFatherInfo({
              occupation: value,
            });
          }}
          label="Occupation"
          name="new-student-father-occupation"
        />
      </div>
      <div className="flex-1">
        <SectionHeader
          headerText="Mother info"
          subText="Please provide essential details about the student's mother for admission purposes."
        />
        <InputField
          value={motherInfo?.name || ''}
          setValue={(value) => {
            setUpdatedMotherInfo({
              name: value,
            });
          }}
          label="Name*"
          name="new-student-father-name"
          isRequiredFocusonValidation
        />
        <InputField
          value={motherInfo?.mobile || ''}
          setValue={(value) => {
            setUpdatedMotherInfo({ mobile: value });
          }}
          label="Mobile*"
          name="new-student-mother-mobile"
          isRequiredFocusonValidation
        />
        <InputField
          value={motherInfo?.telno || ''}
          setValue={(value) => {
            setUpdatedMotherInfo({
              telno: value,
            });
          }}
          label="Tel no"
          name="new-student-mother-telno"
          isRequiredFocusonValidation
        />
        <InputField
          value={motherInfo?.occupation || ''}
          setValue={(value) => {
            setUpdatedMotherInfo({
              occupation: value,
            });
          }}
          label="Occupation"
          name="new-student-mother-occupation"
        />
      </div>
    </div>
  );
};
